export default __webpack_public_path__ + "static/media/inseam_bone.c66ef89a.svg";